import { useDispatch } from 'react-redux'
import { useCallback } from 'react'

export default (chart) => {
  const dispatch = useDispatch()

  return useCallback(
    () =>
      dispatch({
        type: 'STATISTICS/SET_CHART_TYPE',
        payload: { type: chart.chartType === 'Line' ? 'Bar' : 'Line' },
      }),
    [chart],
  )
}
